import React from 'react';

/** Hook to run a callback whenever browser window resizes */
export function useWindowResize(callback: () => void) {
  React.useEffect(() => {
    window.addEventListener('resize', callback);
    return () => window.removeEventListener('resize', callback);
  }, [callback]);
}
